import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef, OnInit } from '@angular/core';
@Component({
    // moduleId: module.id,
    selector: 'icon-chart-square',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    opacity="0.5"
                    d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
                <path d="M7 18L7 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M17 18V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M12 18V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
        </ng-template>
    `,
})
export class IconChartSquareComponent implements OnInit{
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private readonly viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
